import { useForm as useHookForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export type FormValue = {
  hanyomRan: string;
  variety: string;
  shape: string;
};

const useForm = () => {
  const schema = Yup.object().shape({
    shape: Yup.string(),
    variety: Yup.string(),
  });

  const formInfo = useHookForm<FormValue>({
    resolver: yupResolver(schema),
    shouldFocusError: true,
  });
  return { ...formInfo };
};

export default useForm;
